import { GetDataPromise } from "./SendingData";

export function paramsToObject(entries, defaults = {}) {
    const result = defaults
    if(typeof entries === "string"){
      entries = new URLSearchParams(entries);
    }
    for(const [key, value] of entries) { // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
    return result;
}

export function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
export const convertNumToEn = (str) => {
  var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
  var EnglishNumbers  = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];
  if(typeof str === 'string')
  {
  for(var i=0; i<10; i++)
  {
      str = str.replace(persianNumbers[i], i).replace(EnglishNumbers[i], i);
  }
  }
  return str;
}


export const translateTo = async (base = "", lang = "en", onChange = () => {}) => {
  let urlParams = new URLSearchParams();
  urlParams.append("lan", lang);
  urlParams.append("text", base);
  let response = await GetDataPromise("https://translate.luxintrip.com/api/translate?" + urlParams.toString());
  let parsed = JSON.parse(response);
  if(parsed.status){
    onChange(parsed.data);
    return;
  } else {
    return "";
  }
}